import { Box, Dialog, Modal, } from "@mui/material";
import styled from "styled-components";
import CustomDataGrid from "../../shared/Shared Utils/CustomDataTable";
import { COUNTRY_ITEM_API, MANUFACTURER_API } from "../../shared/Shared Utils/AppData";
import { getShare } from "../../../Utils/NumberUtils";

const MANUFACTURER_COLUMN = [
    { field: "RowNumber", headerName: " ", width: 50 },
    {
      field: "Country",
      renderHeader: (params) => <strong>{"Country"}</strong>,
      flex: 1,
    },
    {
      field: "ProductCN",
      renderHeader: (params) => <strong>{"Item"}</strong>,
      flex: 1,
    },
    {
      field: "AmountBirr",
      renderHeader: (params) => <strong>{"Value (ETB)"}</strong>,
      flex: 1,
      type: "decimalZero",
    },
    {
      field: "ReceivedbyAllRecipants",
      renderHeader: (params) => <strong>{"Share"}</strong>,
      flex: 1,
      valueGetter: getShare,
    },
  ];

export const CountryItemsModal = ({open, handleClose, countryCode, programCode, modeCode}) => {

  return (
    
    <Modal
            open={open}
            onClose={() => handleClose(false)}
        >
        <Box 
          className="modal-class"  
          style={{
            padding: "1rem",
            paddingTop: "3rem",
            position: "relative",
            width: "80%",
            height: "38rem",
            background: "white",
            }}
          >
            <CustomDataGrid
              component_config={{
                title: "Country Items",
                data_source_api: COUNTRY_ITEM_API,
                data_property: "Data",
                columns: MANUFACTURER_COLUMN,
                wgInfoId: 'wgManufacturerGrid',
                isSOH: false,
                width: "72vw",
                pageSize: 5,
                use_default_filter_params: false,
                defaultFilterParams: {ModeCode: modeCode, Alpha3code: countryCode, ProgramCode: programCode },
              }}
            />
          </Box>
        </Modal>
  )
}
  
const DialogWrapper = styled(Dialog)`
  .MuiDialog-paper {
    border-radius: 11px;
  }
  .header {
    background-color: #12b3b7;
    color: white;
  }
`;